import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class ProposalOptionName extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            optionKey: this.props.value || '',
        }
        this.supportedOptions = [
            'show-line-item-price',
            'show-taxes',
            'show-description',
            'show-images',
            'show-documents',
            'primary-color',
            'secondary-color',
            'group-title-background-color',
            'background-color',
            'background-image-id',
            'banner-color',
            'font',
            'additional-color-1',
            'additional-color-2',
            'additional-color-3',
            'print-size', 
        ]
    }

    render() {
        switch (this.state.optionKey) {
            case 'show-line-item-price':
                return <FormattedMessage
                    id='proposal.options.show_line_item_price_label'
                    defaultMessage='Show line item price'
                />
            case 'show-taxes':
                return <FormattedMessage
                    id='proposal.options.show_taxes_label'
                    defaultMessage='Show taxes'
                />
            case 'show-images':
                return <FormattedMessage
                    id='proposal.options.show_images_label'
                    defaultMessage='Show image attachments'
                />
            case 'show-documents':
                return <FormattedMessage
                    id='proposal.options.show_documents_label'
                    defaultMessage='Show document attachments'
                />
            case 'show-description':
                return <FormattedMessage
                    id='proposal.options.show_description_label'
                    defaultMessage='Show project description'
                />
            case 'primary-color':
                return <FormattedMessage
                    id='proposal.options.primary_color_label'
                    defaultMessage='Primary color'
                />
            case 'secondary-color':
                return <FormattedMessage
                    id='proposal.options.secondary_color_label'
                    defaultMessage='Secondary color'
                />
            case 'button-color':
                return <FormattedMessage
                    id='proposal.options.button_color_label'
                    defaultMessage='Buttons color'
                />
            case 'background-color':
                return <FormattedMessage
                    id='proposal.options.background_color_label'
                    defaultMessage='Background color'
                />
            case 'background-image-id':
                return <FormattedMessage
                    id='proposal.options.background_image_label'
                    defaultMessage='Background image'
                />
            case 'group-title-background-color':
                return <FormattedMessage
                    id='proposal.options.group_title_background_color_label'
                    defaultMessage='Group name background color'
                />
            case 'banner-color':
                return <FormattedMessage
                    id='proposal.options.banner_color_label'
                    defaultMessage='Banner color'
                />
            case 'additional-color-1':
                return <FormattedMessage
                    id='proposal.options.additional_color_1_label'
                    defaultMessage='Additional color 1'
                />
            case 'additional-color-2':
                return <FormattedMessage
                    id='proposal.options.additional_color_2_label'
                    defaultMessage='Additional color 2'
                />
            case 'additional-color-3':
                return <FormattedMessage
                    id='proposal.options.additional_color_3_label'
                    defaultMessage='Additional color 3'
                />
            case 'font':
                return <FormattedMessage
                    id='proposal.options.font_label'
                    defaultMessage='Font'
                />
            case 'print-size':
                return <FormattedMessage
                    id='proposal.options.print_size_label'
                    defaultMessage='Select print size'
                />
            default:
                return ''
        }
    }

}

export default ProposalOptionName


// WEBPACK FOOTER //
// ./src/common/proposal/optionname.component.jsx